import React, { useEffect, useCallback } from 'react';
import PropType from 'prop-types';
import { RemoveScroll } from 'react-remove-scroll';
import './modal.scss';

const SimpleModal = ({
    children,
    className,
    classNameBody,
    closeModalCallback,
    style,
    styleBody
}) => {
    const closeOnEscape = useCallback(
        e => {
            if (e.keyCode === 27) {
                e.preventDefault();
                closeModalCallback(e);
            }
        },
        [closeModalCallback]
    );

    useEffect(() => {
        window.addEventListener('keydown', closeOnEscape);
        return () => {
            window.removeEventListener('keydown', closeOnEscape);
        };
    }, [closeOnEscape]);

    return (
        <RemoveScroll allowPinchZoom={true} forwardProps>
            <div
                className={`react-modal d-flex justify-content-center z-modal ${className}`}
                style={style}>
                <div
                    className={`react-modal-body ${classNameBody}`}
                    style={styleBody}>
                    {children}
                </div>
            </div>
        </RemoveScroll>
    );
};

SimpleModal.propTypes = {
    children: PropType.node.isRequired,
    className: PropType.string,
    classNameBody: PropType.string,
    closeModalCallback: PropType.func.isRequired,
    style: PropType.object,
    styleBody: PropType.object
};
SimpleModal.defaultProps = {
    className: '',
    classNameBody: '',
    style: {},
    styleBody: {}
};

export default SimpleModal;
